import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=c4970aa6&scoped=true&"
var script = {}
import style0 from "./icon.vue?vue&type=style&index=0&id=c4970aa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4970aa6",
  null
  
)

component.options.__file = "icon.vue"
export default component.exports